import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Container from '@/components/Container'
import Main from '@/components/Main'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect: 'home',
    component: Container,
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/business',
    name: 'business',
    component: Main,
    children: [
      {
        path: 'home',
        component: () => import('@/views/home'),
        name: '首页'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/defect',
    name: 'defect',
    component: Main,
    children: [
      {
        path: 'defect',
        component: () => import('@/views/defect/Defect'),
        name: '缺陷档案'
      },
      {
        path: 'report',
        component: () => import('@/views/defect/Report'),
        name: '异常处理单'
      },
      {
        path: 'reportPrint',
        component: () => import('@/views/defect/ReportPrint'),
        name: '异常处理单打印'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/inspect',
    name: 'inspect',
    component: Main,
    children: [
      {
        path: 'arrivedMaterial',
        component: () => import('@/views/inspect/ArrivedMaterial'),
        name: '来料检验标准'
      },{
        path: 'workshop',
        component: () => import('@/views/inspect/Workshop'),
        name: '车间检验标准'
      },{
        path: 'semifinished',
        component: () => import('@/views/inspect/Semifinished'),
        name: '半成品检验标准'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/examine',
    name: 'examine',
    component: Main,
    children: [
      {
        path: 'arrived',
        component: () => import('@/views/examine/Arrived'),
        name: '来料检验'
      },
      {
        path: 'first',
        component: () => import('@/views/examine/ExamineFirst'),
        name: '首检'
      },
      {
        path: 'semifinished',
        component: () => import('@/views/examine/ExamineSemifinished'),
        name: '半成品检验'
      },
      {
        path: 'finish',
        component: () => import('@/views/examine/ExamineFinish'),
        name: '成品检验'
      },
      {
        path: 'finishMapping',
        component: () => import('@/views/examine/ExamineFinishMapping'),
        name: '成品字段映射'
      },
      {
        path: 'finishItemMapping',
        component: () => import('@/views/examine/ExamineFinishItemMapping'),
        name: '成品子集字段映射'
      },
      {
        path: 'finishImageMapping',
        component: () => import('@/views/examine/ExamineFinishImageMapping'),
        name: '成品图片映射'
      },
      {
        path: 'template',
        component: () => import('@/views/examine/ExamineTemplate'),
        name: '检验报告模板'
      },
      {
        path: 'examineReport',
        component: () => import('@/views/examine/ExamineReport'),
        name: '检验报告打印'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/configuration',
    name: 'configuration',
    component: Main,
    children: [
      {
        path: 'sampleType',
        component: () => import('@/views/configuration/SampleType'),
        name: '样本字码表'
      },
      {
        path: 'sampleAmount',
        component: () => import('@/views/configuration/SampleAmount'),
        name: '样本允收表'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/reportForm',
    name: 'reportForm',
    component: Main,
    children: [
      {
        path: 'fanReport',
        component: () => import('@/views/reportForm/fanReport'),
        name: 'fanReport'
      }]
  },
  {
    path: '/system',
    name: 'system',
    component: Main,
    children: [
      {
        path: 'user',
        component: () => import('@/views/system/User'),
        name: '用户管理'
      },{
        path: 'role',
        component: () => import('@/views/system/Role'),
        name: '角色管理'
      },{
        path: 'permission',
        component: () => import('@/views/system/Permission'),
        name: '权限管理'
      }
      ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/document',
    name: 'document',
    component: Main,
    children: [
      {
        path: 'documentManagement',
        component: () => import('@/views/document/DocumentManagement'),
        name: '文件管理'
      },
      {
        path: 'folderPermission',
        component: () => import('@/views/document/FolderPermission'),
        name: '文件夹权限管理'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/test',
    name: 'test',
    component: Main,
    children: [
      {
        path: 'item',
        component: () => import('@/views/test/TestItem'),
        name: '测试项目管理'
      },
      {
        path: 'form',
        component: () => import('@/views/test/TestForm'),
        name: '测试表单'
      },
      {
        path: 'dict',
        component: () => import('@/views/test/TestDict'),
        name: '测试字典'
      },
      {
        path: 'testFormPrint',
        component: () => import('@/views/test/TestFormPrint'),
        name: '测试表单报告打印'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/document/pdf-preview',
    name: 'PdfPreview',
    component: () => import('@/views/document/PdfPreview'),
    meta: {
      requireAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
